import React, { useState } from 'react';
import { Box, IconButton, Menu, MenuItem } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { SUPPORTED_LANGUAGES, LanguageCode } from '../../i18n/languages';
import { pubPath, pubText, hasPublicTranslation } from '../../i18n/publicTranslation';
const LanguageSwitcher: React.FC = () => {
    const { currentLanguage } = useLanguage();
    const location = useLocation();
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);
    if (!hasPublicTranslation(location.pathname)) return null;
    return <>
  <IconButton aria-label={pubText('Language')} aria-haspopup="menu" aria-expanded={Boolean(anchor)} onClick={e => setAnchor(e.currentTarget)} sx={{ color: '#fff', flexShrink: 0, width: 42, height: 42 }}><LanguageIcon /></IconButton>
  <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)} slotProps={{ paper: { sx: { maxHeight: 420, bgcolor: '#191c25', color: '#fff' } } }}>
   {Object.values(SUPPORTED_LANGUAGES).map(language => <MenuItem key={language.code} component={Link} lang={language.code} hrefLang={language.code} to={pubPath(location.pathname, language.code as LanguageCode) + location.search + location.hash} selected={currentLanguage === language.code} onClick={() => setAnchor(null)}>{language.name}</MenuItem>)}
  </Menu>
 </>;
};
export const PublicLanguageLinks: React.FC = () => {
    const location = useLocation();
    const pagePath = hasPublicTranslation(location.pathname) ? location.pathname : '/';
    return <Box component="nav" aria-label={pubText('Language')} sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mt: 4, fontSize: 13 }}>
  {Object.values(SUPPORTED_LANGUAGES).map(language => <Box key={language.code} component={Link} lang={language.code} hrefLang={language.code} to={pubPath(pagePath, language.code as LanguageCode)} sx={{ color: 'rgba(255,255,255,.65)', textDecoration: 'none', '&:hover': { color: '#d8a363' } }}>{language.name}</Box>)}
 </Box>;
};
export default LanguageSwitcher;
